import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/selfie.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-b9126000"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component" }
const _hoisted_2 = { class: "backButton" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("＜ Back")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topImages" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "selfie",
    class: "topImage"
  })
], -1))
const _hoisted_5 = { class: "showHide" }
const _hoisted_6 = { class: "wrapSns" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "",
  target: "_blank",
  class: "sns"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "",
  target: "_blank",
  class: "sns"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "",
  target: "_blank",
  class: "sns"
}, null, -1))
const _hoisted_10 = { class: "wrapContents" }
const _hoisted_11 = { class: "whoAmI" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sectionTitle" }, null, -1))
const _hoisted_13 = { class: "line sectionTitle" }
const _hoisted_14 = { class: "line" }
const _hoisted_15 = { class: "line" }
const _hoisted_16 = { class: "line" }
const _hoisted_17 = { class: "Job" }
const _hoisted_18 = { class: "sectionTitle" }
const _hoisted_19 = { class: "line" }
const _hoisted_20 = { class: "line" }
const _hoisted_21 = { class: "line" }
const _hoisted_22 = { class: "History" }
const _hoisted_23 = { class: "sectionTitle" }
const _hoisted_24 = { class: "line" }
const _hoisted_25 = { class: "line" }
const _hoisted_26 = { class: "line" }
const _hoisted_27 = { class: "Like" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sectionTitle" }, "趣味", -1))
const _hoisted_29 = { class: "line" }
const _hoisted_30 = { class: "line" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _ctx.$C.route.home
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_fa_icon, { icon: ['fab', 'twitter'] }),
        _hoisted_8,
        _hoisted_9
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t('about.whoAmI.title')), 1),
        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t('about.whoAmI.name')), 1),
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.t('about.whoAmI.birth')), 1),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.t('about.whoAmI.where')), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.t('about.jobTitle')), 1),
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.t('about.job3')), 1),
        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.t('about.job2')), 1),
        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.t('about.job1')), 1)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.t('about.historyTitle')), 1),
        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.t('about.history3')), 1),
        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.t('about.history2')), 1),
        _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.t('about.history1')), 1)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.t('about.like1')), 1),
        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.t('about.like2')), 1)
      ]),
      _hoisted_31
    ])
  ]))
}